import * as types from 'constants/ActionTypes';
import { AUDIT_STATISTICS_URL } from 'constants/ApiConstants';

export const fetchAuditStatistics = (links, params) => ({
  type: types.FETCH_AUDIT_STATISTICS_REQUEST,
  links,
  params,
});

export const fetchStatisticsCount = params => ({
  type: types.FETCH_AUDIT_STATISTICS_COUNT_REQUEST,
  params,
});

export const fetchStatisticsCountSuccess = auditStatistics => ({
  type: types.FETCH_AUDIT_STATISTICS_COUNT_SUCCESS,
  auditStatistics,
});

export const fetchStatisticsCountFailure = error => ({
  type: types.FETCH_AUDIT_STATISTICS_COUNT_FAILURE,
  error,
});

export const fetchStatisticsAvgTime = (params = {}) => ({
  type: types.FETCH_AUDIT_STATISTICS_AVG_TIME_REQUEST,
  payload: {
    request: {
      url: `${AUDIT_STATISTICS_URL}/reduce`,
      params: {
        ...params,
        reducer: 'elapsedTime,avg',
        exist: 'author',
      },
    },
  },
});

export const fetchStatisticsAvgTimeSuccess = payload => ({
  type: types.FETCH_AUDIT_STATISTICS_AVG_TIME_SUCCESS,
  payload,
});

export const fetchStatisticsAvgTimeFailure = message => ({
  type: types.FETCH_AUDIT_STATISTICS_AVG_TIME_FAILURE,
  error: true,
  message,
});

export const fetchLinkedAudits = (links, params) => ({
  type: types.FETCH_AUDIT_STATISTICS_AUDITS_REQUEST,
  links,
  params,
});

export const fetchLinkedAuditsSuccess = auditStatistics => ({
  type: types.FETCH_AUDIT_STATISTICS_AUDITS_SUCCESS,
  auditStatistics,
});

export const fetchLinkedAuditsFailure = error => ({
  type: types.FETCH_AUDIT_STATISTICS_AUDITS_FAILURE,
  error,
});

export const fetchAuditStatisticsSuccess = (questionId, auditStatistics) => ({
  type: types.FETCH_AUDIT_STATISTICS_SUCCESS,
  questionId,
  auditStatistics,
});

export const fetchAuditStatisticsDone = () => ({
  type: types.FETCH_AUDIT_STATISTICS_DONE,
});

export const fetchAuditStatisticsFailure = (error, id) => ({
  type: types.FETCH_AUDIT_STATISTICS_FAILURE,
  error,
  id,
});

export const clearAuditStatistics = () => ({
  type: types.CLEAR_AUDIT_STATISTICS,
});

export const clearAuditStatistic = id => ({
  type: types.CLEAR_AUDIT_STATISTIC,
  id,
});

export const addFilter = (id, filter) => ({
  type: types.AUDIT_STATISTICS_ADD_FILTER,
  id,
  filter,
});

export const removeFilter = (id, filter) => ({
  type: types.AUDIT_STATISTICS_REMOVE_FILTER,
  id,
  filter,
});

export const removeFilters = () => ({
  type: types.AUDIT_STATISTICS_REMOVE_FILTERS,
});

export const setPeriod = period => ({
  type: types.SET_AUDIT_STATISTICS_PERIOD,
  period,
});
